import React from 'react';
import Products from '../components/Products';
import './ProductsPage.css';

const ProductsPage = ({ selectedCategory, selectedSubcategory, onAddToCart }) => {
  return (
    <div className="products-page">
      <Products
        selectedCategory={selectedCategory}
        selectedSubcategory={selectedSubcategory}
        onAddToCart={onAddToCart}
      />
    </div>
  );
};

export default ProductsPage;
